import { render } from "./DeleteReportModal.vue?vue&type=template&id=9914279a&ts=true"
import script from "./DeleteReportModal.vue?vue&type=script&lang=ts"
export * from "./DeleteReportModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__